import { bottles } from 'src/axious/bottles'
import { handleAxiosError } from 'src/utils/errorHandling'

export const sendingRequestToJoinBottle = async (bottleId: number, source: 'STARS' | 'ADS', entrySum: number) => {
  try {
    let requestConfig =
      source === 'STARS'
        ? { source, stars_amount: entrySum, commission: 0 }
        : {
            source,
            ads_count: entrySum,
          }

    if (source === 'STARS') {
      localStorage.setItem('numberStarsToTickets', entrySum.toString())
    }

    const res = await bottles('post', `/${bottleId}/join-lottery`, requestConfig)

    return res
  } catch (err) {
    const errorMessage = handleAxiosError(err)
    console.log(errorMessage)
  }
}
